// /app/frontend/src/config/pricing.js
// Central pricing configuration — single source of truth for the paywall.
// All gate logic across the app reads from this file.

// ──────────────────────────────────────────────────────────────────────────
// Paywall date — controlled by three constants.
//
// To move the paywall, A NON-DEVELOPER ONLY NEEDS TO CHANGE `PAYWALL_DAY`.
// Set it to the day of the month the paywall should go live. Increase the
// number to push the paywall later; decrease to flip it on sooner. The other
// two constants (year / month) only change if you cross a month/year boundary.
//
// Notes:
//  • PAYWALL_MONTH is **0-indexed** (Jan = 0, Feb = 1, … Jul = 6, Dec = 11).
//  • The comparison runs at midnight IST (UTC+5:30).
// ──────────────────────────────────────────────────────────────────────────
export const PAYWALL_YEAR  = 2026;
export const PAYWALL_MONTH = 10; // 0-indexed → 10 = November
export const PAYWALL_DAY   = 15; // ← change ONLY this to move the date (extended from 31 Oct on 5 Nov 2026)

// Midnight IST = 00:00 UTC+5:30 ≡ 18:30 UTC the previous day.
export const PAYWALL_DATE = new Date(Date.UTC(
  PAYWALL_YEAR,
  PAYWALL_MONTH,
  PAYWALL_DAY - 1, // back one day because we subtract 5:30 below
  18, 30, 0,
));

export const isPricingLive = () => new Date() >= PAYWALL_DATE;

// Human label for the last free day, e.g. "November 14" (the paywall starts at midnight IST
// at the start of PAYWALL_DAY, so the last free day is the day before). Use this in copy
// instead of hard-coding a date.
const _lastFree = new Date(Date.UTC(PAYWALL_YEAR, PAYWALL_MONTH, PAYWALL_DAY - 1));
export const FREE_UNTIL_LABEL = _lastFree.toLocaleDateString("en-US", { month: "long", day: "numeric", timeZone: "UTC" });
export const PAYWALL_LABEL = new Date(Date.UTC(PAYWALL_YEAR, PAYWALL_MONTH, PAYWALL_DAY))
  .toLocaleDateString("en-US", { month: "long", day: "numeric", timeZone: "UTC" });

export const GATED_ROUTES = [
  '/advisor',
  '/financial',
  '/decision-report',
];

export const PARTIAL_ROUTES = {
  '/top-picks': { freeLimit: 3 },
  '/compare':   { freeLimit: 2 },
};
